<template>
  <div id="schedavini">
    <div class="row scheda">
      <div class="col-lg-12 directory">
        <router-link :to="{name: 'homepage'}">Home</router-link>
        /
        <router-link :to="{name: 'shop'}">Vini</router-link>
        / {{ wine.nome }}
      </div>
      <div class="col-lg-6 dati">
        <div class="col-lg-12 titolo"><h1 style="font-size: 55px">{{ wine.nome }}</h1></div>
        <!-- Vitigni -->
<!--        <div class="col-lg-12 box-price" >-->
<!--          <div class="price">-->
<!--            <img src="../../static/image/euroQuvestra.svg" class="euro">-->
<!--            <div class="prezzo">Prezzo: {{Number.isInteger(wine.price) ? wine.price + ',00' : wine.price  }}</div>-->
<!--          </div>-->
<!--          <div class="info-price">Per maggiori informazioni scrivere a <a href="mailto:info@tenutaballerio.com"> info@tenutaballerio.com</a>-->
<!--          </div>-->
<!--        </div>-->
        <div class="col-lg-12 sez">
          <div class="sottotitolo">
            <img src="../../static/image/vitigni.png" class="foto">
            <span>{{ $t('wines') }}</span>
          </div>
          <div class="testo" v-html="wine.vitigni">
          </div>
        </div>
        <!-- Vendemmia -->
        <div class="col-lg-12 sez">
          <div class="sottotitolo">
            <img src="../../static/image/visiteinCantina/grappolo.png" class="foto">
            <span>{{ $t('harvest') }}</span>
          </div>
          <div class="testo" v-html="wine.vendemmia">
          </div>
        </div>
        <!-- Produzione -->
        <div class="col-lg-12 sez">
          <div class="sottotitolo">
            <img src="../../static/image/botteSdraiata.png" class="foto">
            <span>{{ $t('production') }}</span>
          </div>
          <div class="testo" v-html="wine.produzione">
          </div>
        </div>
        <!-- Caratteristiche -->
        <div class="col-lg-12 sez">
          <div class="sottotitolo">
            <img src="../../static/image/degustazione.png" class="foto">
            <span>{{ $t('features') }}</span>
          </div>
          <div class="testo" v-html="wine.caratteristiche">
          </div>
        </div>
        <div  class="col-lg-12 sez" style="font-style:italic;">Per maggiori informazioni scrivere a <a href="mailto:info@tenutaballerio.com"> info@tenutaballerio.com</a></div>
        <!-- Prezzo -->
        <!--        <div class="col-lg-12 sez">-->
        <!--          &lt;!&ndash;HubSpot Call-to-Action Code &ndash;&gt;<span class="hs-cta-wrapper" id="hs-cta-wrapper-86d6e0bf-605a-41dc-8cdd-f0c6a0e3f2a0"><span class="hs-cta-node hs-cta-86d6e0bf-605a-41dc-8cdd-f0c6a0e3f2a0" id="hs-cta-86d6e0bf-605a-41dc-8cdd-f0c6a0e3f2a0">&lt;!&ndash;[if lte IE 8]>
        <div id="hs-cta-ie-element"></div>
        <![endif]&ndash;&gt;<a href="https://cta-redirect.hubspot.com/cta/redirect/5864348/86d6e0bf-605a-41dc-8cdd-f0c6a0e3f2a0"  target="_blank" ><img class="hs-cta-img" id="hs-cta-img-86d6e0bf-605a-41dc-8cdd-f0c6a0e3f2a0" style="border-width:0px;" src="https://no-cache.hubspot.com/cta/default/5864348/86d6e0bf-605a-41dc-8cdd-f0c6a0e3f2a0.png"  alt="VISITA LO SHOP ONLINE"/></a></span></span>&lt;!&ndash; end HubSpot Call-to-Action Code &ndash;&gt;-->
        <!--        </div>-->
        <!-- Prezzo -->
        <!-- <div class="col-lg-12 sez">
           <div class="sottotitolo">
             <img src="../../static/image/prezzowhite.png" style="width: 45px; margin-right: 13px">
             <span>{{$t("price")}}</span>
             <div class="col-lg-6 col-sm-6 col-md-6 col-6 testo" v-price v-if="wine.price">{{wine.price}}</div>
             <div class="row">
               <div class="quantity">Qtà:&nbsp;<input type="number" name="quantity"
                                                                                       min="1" :max="wine.qntyProd" class="quantità"
                                                                                       id="qua"
                                                                                       oninput="validity.valid||(value=1)"
                                                                                       v-model="qntyOrd"
                                                                                       v-validate="'required'">
               </div>
               <b-btn class="info" @click="addToCart">Aggiungi al carrello</b-btn>
               <div class="row buttonsInfo">
                 <div class="linkcont">
                   <router-link class="links" :to="{name: 'shop'}">
                     {{$t("shop")}}
                   </router-link>
                 </div>
                 <div class="linkcont">
                   <router-link class="links" :to="{name: 'visitecantina'}">
                     {{$t("cellar")}}
                   </router-link>
                 </div>
               </div>
             </div>
           </div>
         </div>-->
      </div>
      <div class="col-lg-6" style="text-align: center">
        <img class="fotona" v-if="wine.image" :src="'static/image/products/'+wine.image+'.png'">
      </div>
    </div>
    <div class="row gastronomia">
      <div class="col-lg-5 offset-lg-1 col-12 col-sm-12 cibo">
        <div class="row">
          <div class="col-lg-6 col-sm-6 col-md-6 col-6 dfoto"><img v-if="wine.foodImage"
                                                                   :src="'static/image/abbinamenti/'+wine.foodImage+'/1.jpg'"
                                                                   class="foto">
          </div>
          <div class="col-lg-6 col-sm-6 col-md-6 col-6 dfoto"><img v-if="wine.foodImage"
                                                                   :src="'static/image/abbinamenti/'+wine.foodImage+'/2.jpg'"
                                                                   class="foto">
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-sm-6 col-md-6 col-6 dfoto"><img v-if="wine.foodImage"
                                                                   :src="'static/image/abbinamenti/'+wine.foodImage+'/3.jpg'"
                                                                   class="foto">
          </div>
          <div class="col-lg-6 col-sm-6 col-md-6 col-6 dfoto"><img v-if="wine.foodImage"
                                                                   :src="'static/image/abbinamenti/'+wine.foodImage+'/4.jpg'"
                                                                   class="foto">
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <span class="titolo"><h2>{{ $t('gastronomic') }}</h2></span>
        <span class="testo" v-html="wine.food">
        </span>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import MainSlider from './MainSlider'
import Footer from './Footer'
import Bus from './Bus'
import {utility} from '../mixins/utility'

export default {
  name: 'schedavini',
  components: {Footer, MainSlider},
  mixins: [utility],
  data () {
    return {
      qntyOrd: 1,
      wine: {
        id: '',
        nome: '',
        category: '',
        vitigni: '',
        vendemmia: '',
        produzione: '',
        caratteristiche: '',
        food: '',
        foodImage: '',
        price: ''
      },
      certificates: {
        Bonarda: {
          numFoto: 4
        },
        Chardonnay: {
          numFoto: 2
        },
        Gaudium: {
          numFoto: 4
        },
        Merlot: {
          numFoto: 2
        },
        PinotNero: {
          numFoto: 6
        },
        Sinfoniainbianco: {
          numFoto: 4
        },
        Sinfoniainrosso: {
          numFoto: 4
        },
        Zephiro: {
          numFoto: 5
        },
        Symposium: {
          numFoto: 0
        },
        Croatina: {
          numFoto: 0
        }
      }
    }
  },
  i18n: {
    fallbackLocale: 'it', // default lang,
    messages: {
      it: {
        wines: 'Vitigni',
        harvest: 'Vendemmia',
        production: 'Produzione',
        features: 'Caratteristiche',
        price: 'Prezzo',
        shop: 'Vai allo Shop',
        cellar: 'Visita in cantina',
        gastronomic: 'Abbinamenti Gastronomici Consigliati',
        prod_add: 'Prodotto aggiunto al carrello',
        prb_prod_add: 'Errore, inserire quantità'
      },
      en: {
        wines: 'Wines',
        harvest: 'Harvest',
        production: 'Production',
        features: 'Features',
        price: 'Price',
        shop: 'Go to the Shop',
        cellar: 'Visit to the cellar',
        gastronomic: 'Gastronomic Matches Suggested',
        prod_add: 'Prodotto aggiunto al carrello',
        prb_prod_add: 'Errore, inserire quantità'
      }
    }
  },
  methods: {
    getWine: function () {
      this.wine = this.listWinesDetail.filter(el => el.id === parseInt(this.$route.params.id))[0]
    },
    cleanName (name) {
      return name.replace(/\s/g, '')
    }
  },
  mounted: function () {
    this.getWine()
    window.scroll(0, 0)
  }
}
</script>

<style lang="less">
@import "../assets/less/variabili.less";
@import "../assets/less/font.less";

#schedavini input[type=number] {
  text-align: center;
  font-weight: 700;
  outline: none;
}

#schedavini {
  .main {
    .agile {
      .agile__track {
        max-height: 600px;
      }
    }
  }

  .scheda {
    margin-right: 0px;
    background-color: @lightBlack;
    color: white;
    padding-bottom: 30px;
    .box-price{
      height: 120px;
      background:	#909090; margin-left: 18px;margin-bottom: 25px
    }
    .price{
      margin: 0;
      position: absolute;
      top: 20%;
    }
    .euro {
      height: 30px;float:left; margin-right: 30px; margin-top: 12px
    }
    .info-price{
      position: absolute; top: 60%; left: 75px;
      color: lightgrey;
      font-size: 18px;
    }
.prezzo{
  float: left; font-size: 35px; font-weight: bold
}
    .directory {
      padding-left: 100px;
      padding-top: 80px;
      letter-spacing: 1px;
      .set-font();
    }

    .dati {
      padding-left: 200px;
      padding-top: 60px;

      .titolo {
        padding-left: 80px;
        border: 1px;
        border-bottom: .5px;
        height: 75px;
        text-align: left;
        margin-bottom: 10px;
        .set-font-title(@weight: bold);
      }

      .sez {
        padding-bottom: 20px;
      }

      .sottotitolo {
        .set-font-title(@weight: bold, @size: 25px);

        .foto {
          margin-right: 20px;
          width: 35px;
        }

        .quantity {
          .set-font-latoRegular();
          margin-top: 30px;
          margin-right: 30px;
          margin-left: 75px;

          .quantità {
            width: 50%;
            height: 80%;
            background-color: #585353;
            color: white;
            border-color: @darkGray;
          }
        }
      }

      .testo {
        padding-left: 70px;
        letter-spacing: 1px;
        .set-font();
      }

      .info {
        width: 250px;
        background-color: @myOrange;
        border-color: @borderOrange;
        text-align: center;
        letter-spacing: 1px;
        padding-top: 10px;
        padding-bottom: 10px;
        margin-top: 25px;
        .set-font()
      }

      .buttonsInfo {
        padding: 0;
        text-align: center;

        .linkcont {
          padding-right: 50px;
          padding-top: 50px;
          padding-left: 90px;
          text-align: center;

          .links {
            letter-spacing: 1px;
            color: @lightGold !important;
            .set-font(@size: 20px)
          }
        }

      }
    }

    .fotona {
      width: 500px;
      padding-top: 60px;
      margin-left: auto;
    }

    .certifications {
      padding-top: 60px;
      top: -11px;
      position: absolute;
      margin-top: 0;
      right: 110px;

      .certification {
        width: 70px;
        margin-right: 80px;
        padding-top: 15px;
      }
    }

    .foto {
      width: 30%;
    }
  }

  .gastronomia {
    background-color: @darkGray;
    margin-right: 0px;
    margin-left: 0px;
    padding-top: 50px;
    padding-bottom: 50px;

    .cibo {
      padding-right: 120px;
      padding-left: 120px;

      .dfoto {
        padding-right: 3px;

        .foto {
          width: 100%;
          height: 90%;
        }
      }
    }

    .titolo {
      text-align: left;
      .set-font-title(@weight: bold);
    }

    .testo {
      .set-font(@size: 22px);
    }
  }
}

@media (max-width: 767px) {
  #schedavini {

    .row {
      margin-left: 0px;
      margin-right: 0px;
    }

    .scheda {
      padding-right: 3px;
      padding-bottom: 70px;

      .fotona {
        padding-top: 20px;
        width: 80%;
        height: 100%;
        margin-left: 0px;
      }

      .certifications {
        padding-top: 20px;
        right: 50px;

        .certification {
          width: 50px;
          margin-right: 0px;
        }
      }

      .directory {
        padding-left: 10%;
        padding-top: 5%;
        .set-font(@size: 14px);
      }

      .dati {
        padding: 10px;
        padding-top: 10%;

        .titolo {
          height: 55px;
          margin-bottom: 20px;
          padding-left: 10px;
          .set-font-title(@weight: bold, @size: 37px);
        }

        .sez {
          padding-bottom: 1px;
        }

        .sottotitolo {
          .set-font-title(@weight: bold, @size: 20px);

          .foto {
          }

          .quantity {
            .set-font-latoRegular();
            margin-top: 20px;
            margin-left: 0px;
            margin-right: 5px;
            width: 140px;

            .quantità {
              width: 50%;
              height: 100%;
            }
          }
        }

        .testo {
          padding-left: 50px;
          .set-font(@size: 14px);
        }

        .info {
          width: 50%;
          margin-top: 20px;
          .set-font(@size: 11px);

          .link {
          }
        }

        .buttonsInfo {
          justify-content: center;

          .linkcont {
            padding-right: 20px;
            padding-top: 30px;
            padding-left: 20px;
            text-align: center;

            .links {
              .set-font(@size: 16px)
            }
          }

        }
      }

      .foto {
      }
    }

    .gastronomia {
      height: auto;
      padding-left: 3px;

      .cibo {
        padding-left: 0px;
        padding-right: 3px;

        .dfoto {
          padding-right: 15px;

          .foto {
          }
        }
      }

      .testo {
      }

      .titolo {
        text-align: left;
        .set-font-title(@weight: bold, @size: 37px);
      }

      .testo {
        .set-font(@size: 14px);
      }
    }
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  #schedavini {
    .scheda {
      .directory {
      }

      .dati {
        padding-left: 60px;
        padding-top: 35px;

        .titolo {
        }

        .sez {
          padding-bottom: 5px;
        }

        .sottotitolo {
          .foto {
          }

          .quantity {
            width: 200px;
          }
        }

        .testo {
          padding-left: 80px;
        }

        .info {
          .link {
          }
        }
      }

      .foto {
      }
    }

    .gastronomia {
      height: auto;

      .cibo {
        padding-right: 2px;
        padding-left: 20px;

        .dfoto {
          .foto {
            width: 90%;
          }
        }
      }

      .testo {
      }
    }
  }
}

@media (min-width: 1024px) and (max-width: 1366px) {
  #schedavini {
    .scheda {
      .directory {
        padding-left: 10%;
        padding-top: 5%;
      }

      .certifications {
        right: 0px;
      }

      .dati {
        .titolo {
        }

        .sez {
          padding-bottom: 10px;
        }

        .sottotitolo {
          .quantity {
            width: 150px;
            margin-left: 20px;
          }

          .foto {
          }
        }

        .testo {
          padding-left: 60px;
        }

        .buttonsInfo {
          .linkcont {
            padding-right: 30px;
            padding-left: 60px;
          }
        }

        .info {
          width: 230px;

          .link {
          }
        }
      }

      .foto {
      }
    }

    .gastronomia {
      .cibo {
        .dfoto {
          .foto {
          }
        }
      }

      .testo {
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SchedaVini.vue